const GOOGLE_API_KEY = 'AIzaSyDpHdNA79ZQFvlwDYBeoHgT_AFsvIux3JE';

export default GOOGLE_API_KEY;
